import { AutogenModelCalculateTax, AutogenRowCalculateTax } from "./autogen/AutogenModelCalculateTax";

export class ModelCalculateTax extends AutogenModelCalculateTax<RowCalculateTax> {
	constructor() {
		super(RowCalculateTax);
	}
}

export class RowCalculateTax extends AutogenRowCalculateTax {
}